// docs.sentry.io/platforms/javascript/configuration/filtering/ - documentation

export const ignoreList = [
  `Converting circular structure to JSON
  --> starting at object with constructor 'HTMLAnchorElement'
  |     property '__reactFiber$o2eqdf5tol' -> object with constructor 'zu'
  --- property 'stateNode' closes the circle`,
  /Cannot read properties of undefined (reading 'initialised')/,
  /Can't find variable: Notification/,
  /Non-Error promise rejection captured with value: Web push settings not configured on MoEngage dashboard: Dashboard --> Settings --> Channel --> Push/,
  /Can't find variable: fbq/,
  /NotFoundError: Failed to execute 'transaction' on 'IDBDatabase': One of the specified object stores was not found./,
  /TypeError: this.Eg.close is not a function. (In 'this.Eg.close()', 'this.Eg.close' is undefined)/,
  /Error: NotFoundError: Failed to execute 'transaction' on 'IDBDatabase': One of the specified object stores was not found./,
  /Can't find variable: HTMLDialogElement/,
  /Cannot read properties of undefined (reading 'domInteractive')/,
  /Could not load "overlay"./,
  /this.Eg.close is not a function. (In 'this.Eg.close()', 'this.Eg.close' is undefined)/,
  /TypeError: undefined is not an object (evaluating 'F.Oo')/,
  /window.SafeDKWebAppInterface.interceptXmlHttpRequest is not a function/,
  /fbq is not defined/,
  /Argument 1 ('target') to IntersectionObserver.observe must be an instance of Element/,
  /UnknownError: Attempt to delete range from database without an in-progress transaction/,
  /UnknownError: Database deleted by request of the user/,
];
